import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import { LangCode } from '@/config/const';
import Cookies from 'js-cookie';
import { i18n as elementI18n } from 'element-react';
import cnEl from 'element-react/src/locale/lang/zh-CN';
import enEl from 'element-react/src/locale/lang/en';
import esEl from 'element-react/src/locale/lang/es';
import hkEl from 'element-react/src/locale/lang/zh-TW';
import idEl from 'element-react/src/locale/lang/id';
import jaEl from 'element-react/src/locale/lang/ja';
import koEl from 'element-react/src/locale/lang/ko';
import ruEl from 'element-react/src/locale/lang/ru-RU';
import { getQuery, isFromMobile } from './utils/location';

// localStorage 优先：与 account.setLang 一致，避免旧 lang Cookie 覆盖用户切换结果
let lang = (localStorage.getItem('lang') || Cookies.get('lang') || 'zh') as LangCode;

if (isFromMobile()) {
  lang = getQuery('lang') || 'zh';
}

const localeEl = {
  zh: cnEl,
  en: enEl,
  es: esEl,
  hi: enEl,
  hk: hkEl,
  id: idEl,
  ja: jaEl,
  ko: koEl,
  ru: ruEl,
  vi: enEl, // element-react 不支持越南语，使用英文作为 fallback
};
// @ts-ignore
elementI18n.use(localeEl[lang] || enEl);

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    debug: false,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    fallbackLng: 'zh',
    lng: lang,
    backend: {
      loadPath: `/locales/${lang}/translation.json`,
      requestOptions: {
        cache: 'no-store',
      },
    },
  });

export default i18n;
